import queryString from 'query-string'
let __fn_stack = []

/**
 * @desc 
 * @param method {String} 方法
 * @param opts {Object} 参数
 */
const callNative = (method, params) => {
    return new Promise((resolve, reject) => {
        let _fn = () => window.WebViewJavascriptBridge.callHandler(method, params, (res) => {
            if (typeof res === 'string') {
                res = JSON.parse(res)
            }

            if (res && res.status === 'success') {
                resolve(res)
            } else {
                reject(res)
            }
        })

        if (!window.WebViewJavascriptBridge) {
            __fn_stack.push(_fn)
        } else {
            _fn()
        }
    })
}

/**
 * 注册监听native响应
 * @param {*} listenName 
 */
export const registerNative = (listenName) => {
    return new Promise((resolve, reject) => {
        let _fn = () => window.WebViewJavascriptBridge.registerHandler(listenName, () => resolve())
        try {
            if (!window.WebViewJavascriptBridge) {
                __fn_stack.push(_fn)
            } else {
                _fn()
            }
        } catch (error) {
            reject(error)
        }
    })
}


/**
 * @desc 设置页面标题
 * @param title {string} - 标题
 */
export const setTitle = (title) => callNative('setTitle', { title })

/**
 * 获取通讯录
 * @param {*} params 
 * {
 * id,
 * max_count 限制条数
 * }
 */
export const getContacts = (params) => callNative('getContacts', { ...params })

/**
 * 消息盒子
 * @param {*} params {trigger:'event_name', 'extra_params':JSON.stringify({})}
 */
export const showMessageBox = (params) => callNative('showMessageBox', { ...params })

/**
 * @desc 获取地理坐标
 * @param prompt {Object}
 * {
    promptOnDenied: string; // "0"或"1" 没有权限时弹框引导
    promptTitle: string; // 弹框title
    promptContent: string; // 弹框内容
    promptCancelTitle: string; //取消按钮文字
    promptConfirmTitle: string; // 确定按钮文字
 * }
 */
export const getGPS = (prompt) => {
    return callNative('getGPS', {
        "promptOnDenied": "1",
        "promptTitle": "位置信息",
        "promptContent": "为增加您通过机会，请打开设备的GPS",
        "promptCancelTitle": "取消",
        "promptConfirmTitle": "确定",
        ...prompt
    })
}

/**
 * @desc 打印日志
 * @param info {string} - 日志信息
 */
export const log = (info) => callNative('log', { info })

/**
 * @desc 配置标题栏
 * @param params {Object}
 * 
 * {
    leftTitle?: string; // 左边按钮title
    leftAction?: any; // 左边按钮行为 back, close, reload, url, weburl, callback, null
    leftUrl?: string; // 左边统链
    rightTitle?: string; // 右边按钮title
    rightAction?: any; // 右边按钮行为 back, close, reload, url, weburl, callback, null
    rightUrl?: string; // 右边统链
    navigatorTitle: string; // 页面标题
    status?: string; // 导航栏状态
}
*/
export const setNavGation = (params) => {
    if (typeof params === 'string') {
        params = {
            navigatorTitle: params
        }
    }

    let navOpts = {
        leftTitle: "<",
        leftAction: "back",
        leftUrl: "",
        rightTitle: "",
        rightAction: null,
        rightUrl: "",
        navigatorTitle: "",
        ...params
    }

    return callNative('updateBar', navOpts)
}

/**
 * @desc 扫描二维码
 * @param tips {string} - 扫描框内提示文字
 */
export const scanQrCode = (tips) => callNative('scanQrCode', { tips })

/**
 * @desc 控制页面
 * @param action {string} 控制webview页面，back：返回上一页, close：关闭当前页, reload：刷新页面
 */
export const pageControl = (action) => callNative('pageControl', { action })

/**
 * @desc 打开统连f
 * @param view {string} - 统连地址 home/login/web/selectCity
 * @param delay {number} - 延迟一定时间后打开,单位秒
 */
export const openView = (view, params, delay) => callNative('openUrl', { url: `wdsd://${view}?${queryString.stringify(params)}`, delay })

/**
 * 打开客服对话
 */
export const openChat = () => openView('dcschat')

/**
 * @desc 跳转app首页
 */
export const goAppHome = (delay) => openView('home', { page: '1' }, delay)

function uaByKeyword(keyword) {
    let myua = navigator.userAgent.toLowerCase();
    const uaGroup = myua.split(' ');
    let uakw = '';
    for (const uaItem of uaGroup) {
        if (uaItem.indexOf(keyword) === 0) {
            uakw = uaItem;
            break;
        }
    }
    return uakw;
}
/**
 * @desc 判断当前是哪个APP
 */
export const isApp = () => {
    if (!!uaByKeyword('wdph') || !!uaByKeyword('fbwdph')) {
        return 'WED';
    } else if (/com.wanda.kuaiyihua/i.test(navigator.userAgent)) {
        return 'KYH'
    } else if (/com.wandaloans/i.test(navigator.userAgent)) {
        return 'WDD'
    } else if (/MicroMessenger/i.test(navigator.userAgent)) {
        // if (isWeChatMiniProgram()) {
        //     return 'XCX'
        // }
        return 'WX'
    } else {
        return 'H5'
    }
}

/**
 * 跳转我的
 * @param {*} delay 
 */
export const goMyHome = (delay) => openView('home', { page: '3' }, delay)

/**
 * 
 * @param {*} refresh 
 * @param {*} delay 
 */
export const goLogin = (refresh = 1, delay) => openView('login', { refresh }, delay)


/**
 * @desc app内打开h5页面
 * @param url {string}
 */
export const openUrl = (url) => openView(`web`, { url: encodeURIComponent(url) })

/**
 * @desc 选择商店
 * @param current {string|number} - 当前城市代码
 */
export const selectShop = (current) => openView(`selectCity`, { currentcity: current })

/**
 * @desc 调用系统浏览器打开网址
 * @param url {string} - 链接地址
 */
export const openOutSide = (url) => callNative('openOutSide', { url })

/**
 * @desc 获取屏幕信息
 */
export const getScreenInfo = () => callNative('getScreenInfo')

/**
 * @desc 调起分享面板
 * @param params {Object} 
 * {
        title: string; // 标题
        desc: string; // 描述
        thumbImage: string; // 略缩图
        url: string; // 分享的链接
        type: string | number; // 0表示默认的聊天 1表示朋友圈
 * }
 */
export const openShare = (params) => callNative('shared', { ...params })

/**
 * @desc 获取交易密码
 */
export const getTransactionPwd = (params) => callNative('getTransactionPwd', params)

/**
 * @desc 设置交易密码
 */
export const setTransactionPwd = (type = 'set') => callNative('setTransactionPwd', { type })

/**
 * @desc 设置手势密码
 */
export const setFingerPayPwd = (setPwdType = 'firstSet') => callNative('setFingerPayPwd', { setPwdType })

/**
 * 
 * @param setPwdType 
 */
export const getCheckTradePwd = (setPwdType) => callNative('getCheckTradePwd', { setPwdType })

/**
 * @desc 城市选择
 * @param currentCity 
 */
export const getCity = (currentCity) => callNative('getCity', { currentCity })

/**
 * @desc 友盟标签埋点
 * @param evt {Object}
 * {
    event: string; // 事件名称
    label?: any; // 标记内容
 * }
 */
export const ymTrack = (evtName, label) => callNative('event', { evtName, label })

/**
 * @desc 友盟页面埋点
 * @param pageData {Object} 
 *  {
    pageName: string; // 页面名称
    seconds: string | number; // 时长
 * }
 */
export const ymPageNameWithSeconds = (pageData) => callNative('pageNameWithSeconds', { ...pageData })

/**
 * @desc 获取设备信息
 * @param action 
 */
export const getDeviceInfo = (action, params) => callNative('getDeviceInfo', { action, ...params })

/**
 * @desc 获取设备信息
 * @param action 
 */
export const getRiskData = (action) => callNative('getRiskData', { action })

/**
 * 打开手签板
 * @param {*} params 
 */
export const startHwr = (params) => new Promise((resolve, reject) => {
    const _err = {
        "typeAgain": "识别未通过，请重签",
        "typeSkip": "识别未通过，您可点击右上⻆选择跳过此步"
    }

    let { realName, agreement, errorNote, threshold = 5 } = params

    errorNote = { ..._err, ...errorNote }

    callNative('startHwr', { realName, agreement, errorNote, threshold })
        .then((res) => {
            resolve(res)
        }, err => {
            reject(err)
        })
})

/**
 * @desc 扫描身份证
 * @param cardSide {string} 正反面 - front，back
 * @param pictureSourceType {string} 来源 - camera, photo
 * @param ocrType {string} 来源
 */
export const scanIdCard = (cardSide, ocrType = 'ydbs', pictureSourceType = 'camera') => new Promise((resolve, reject) => {
    callNative('getIdCard', { cardSide, ocrType, pictureSourceType })
        .then((res) => {
            if (res && res.image) {
                resolve(res)
            } else {
                reject({ errorMessage: '扫描失败,稍后重试' })
            }
        }, err => {
            let { status = 'error_other' } = err
            let errs = {
                'error_photo_access': '请打开像册权限',
                'error_camera_access': '请打开相机权限',
                'error_other': '获取图片失败'
            }

            reject({ errorMessage: errs[status] })
        })
})

/**
 * @desc 传感器start
 * @param params {Object}
 * {
    action: string;
    updateInterval: number;
    timeout?: number;
 * }
 */
export const sensorStart = (params) => callNative('startSensor', params)

/**
 * @desc 传感器stop
 * @param params {Object}
 * {
    action: string;
    updateInterval: number;
    timeout?: number;
 * }
 */
export const sensorStop = (params) => callNative('stopSensor', params)

/**
 * @desc 评论app弹窗
 */
export const rateApp = () => callNative('rateApp')

/**
 * @desc 弹出系统toast
 * @param content 
 */
export const showToast = (content) => callNative('showToast', { toast_string: content })

/**
 * @desc 截屏统计
 * @param action {string} - start / end
 */
export const screenShots = (action) => callNative('creditScreenshots', { action })

/**
 * @desc 获取相册图片
 */
export const getImageInfo = () => new Promise((resolve, reject) => {
    callNative('getImageInfo').then(res => resolve(res), err => {
        let errorMessage = '', errorStatus = err.status || 'error_other'
        switch (errorStatus) {
            case 'error_camera_access':
                errorMessage = '请打开相机权限';
                break
            case 'error_photo_access':
                errorMessage = '请打开相册权限';
                break
            case 'error_cancel':
                errorMessage = '取消操作'
                break
            default:
                errorMessage = '获取图片失败'
        }

        reject({ errorStatus, errorMessage })
    })
})



/**
 * @desc 获取通话记录和通讯录
 * @param actionType {string} 有三种,分别为callrecord(通话记录)、contact(通讯录)、all(表示全部都传), ios仅支持contact
 * @param isPopup {number} 有两种状态，分别为0和1。0表示需要native弹出窗口提示(默认状态)，1表示不需要native弹出窗口提示
 */
export const getCallandContact = (actionType, isPopup) => callNative('getCallandContact', { actionType, isPopup })

/**
 * @desc 人脸扫描
 * @param actionTime 超时时间
 */
export const scanFace = (actionTime) => new Promise((resolve, reject) => {

    callNative('checkLive', { actionTime }).then(res => resolve(res), err => {
        let errorMessage = '', errorStatus = err.status || 'error_other'
        switch (errorStatus) {
            case 'error_cancel':
                errorMessage = '操作取消'
                break;
            case 'error_camera_access':
                errorMessage = '无法访问摄像头'
                break;
            case 'error_timeout':
                errorMessage = '扫描超时'
                break;
            case 'error_facelost':
                errorMessage = '脸部丢失'
                break;
            case 'error_mask':
                errorMessage = '带着面罩'
                break
            case 'error_action':
                errorMessage = '动作错误'
                break
            default:
                errorMessage = '扫描人脸出错请重试'
                break
        }

        reject({ errorStatus, errorMessage })
    })
})

document.addEventListener('jsBridgeReady', function (bridge) {
    if (__fn_stack.length) {
        __fn_stack.forEach((fn) => {
            fn && typeof fn === 'function' && fn()
        })
        __fn_stack = []
    }
    if (!window.WebViewJavascriptBridge) {
        window.WebViewJavascriptBridge = bridge
    }

}, false)



// WEBPACK FOOTER //
// ./src/utils/libs/jsbridge.js